<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col mt-4 mb-4 card-accont col-lg-8">
        <div class="row mb-2">
          <div class="col-lg-12 text-center card-accont-title">Datos Bancarios</div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <label>
              <b>
                <font-awesome-icon :icon="['fal', 'file-invoice-dollar']" />
              </b> Cuenta Bancaria:
            </label>
            646180229300000001
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <label>
              <b>
                <font-awesome-icon :icon="['fal', 'file-invoice-dollar']" />
              </b> Referencia:
            </label>
            {{ getReference }}
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <label>
              <b>
                <font-awesome-icon :icon="['fal', 'file-invoice-dollar']" />
              </b> Banco:
            </label>
            STP (SIstema de Transferencias y Pagos)
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    getReference () {
      return `${this.user.reference_stp}`
    }
  }
}
</script>
